import { IdTypes, createFeatureScope } from 'bundles/product-features';

const { useProductFeatures } = createFeatureScope({
  enterprise: {
    whitelistOrganizationProgramsForSSOLogin: false,
  },
});

const useWhitelistOrgForSSO = ({
  thirdPartyOrganizationId,
  programId,
}: {
  thirdPartyOrganizationId?: string;
  programId?: string;
}) => {
  const { features: orgFeatures, loading: isOrgProductFeaturesLoading } = useProductFeatures({
    idType: IdTypes.Organization,
    id: thirdPartyOrganizationId || '',
    skip: !thirdPartyOrganizationId,
    ssr: true,
  });

  const { features: programFeatures, loading: isProgramProductFeaturesLoading } = useProductFeatures({
    idType: IdTypes.Program,
    id: programId || '',
    skip: !programId,
    ssr: true,
  });

  return {
    isLoading: isOrgProductFeaturesLoading || isProgramProductFeaturesLoading,
    isOrgOrProgramWhiteListedForSSOLogin:
      orgFeatures.get('enterprise', 'whitelistOrganizationProgramsForSSOLogin') ||
      programFeatures.get('enterprise', 'whitelistOrganizationProgramsForSSOLogin'),
  };
};

export default useWhitelistOrgForSSO;
